import React from 'react'

let listeners = [];

let globalState = {
    loggedOn: false,
    initialized: false,
    jwt: '',
    tenantId: '',
    loginPane: 0,
    selectedDomain: '',
    isBrandingSet: false,
    tabQueryString: '',
    consentTried: false,
}

const setGlobalState = (newState) => {
    globalState = {...newState}
    
    listeners.forEach((listener) => {
        listener(globalState);
    })    
}

export function UseGlobalState() {
    const newListener = React.useState()[1]
    React.useEffect(() => {
        listeners.push(newListener)

        return () => {
            listeners = listeners.filter(listener => listener !== newListener);
        };
    }, 
    // eslint-disable-next-line
    [])
    
    return [ globalState, setGlobalState ]
}